import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

import { AGENT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { NavMenuList } from 'Angular/features/components/navigation/interfaces/nav-menu-list.interface';
import { AngularUser } from 'Angular/interfaces/angular-user.interface';

import { UrlsService } from 'Angular/services/core/urls.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';

import { InviteFriendModalComponent } from 'AccountsApp/ts/features/invite-friend-modal/invite-friend-modal.component';
import { isDesktop } from 'Angular/utils/media';

/**
 *
 * Nav Menu List Component
 *
 * Component for main menu drop down items.
 *
 * Required Attributes:
 *  config: Object representing the menu structure.
 */

@Component({
    standalone: false,
    selector: 'ycn-nav-menu-list',
    templateUrl: './nav-menu-list.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavMenuListComponent implements AfterViewInit {
    @Input() config!: NavMenuList;

    @ViewChild('navMenuListDiv') navMenuListDiv!: ElementRef;

    @ViewChild(InviteFriendModalComponent) ifmc!: InviteFriendModalComponent;

    show: boolean = false;

    USER: AngularUser = window.USER;

    agentNewTab: boolean = this.USER.authenticated && !this.featureService.userHasFeatures([AGENT_FEATURE]);

    agentPageUrl = this.urlService.AGENT.PAGE.replace('#/', '');

    constructor(private featureService: FeatureService, private urlService: UrlsService) {}

    ngAfterViewInit(): void {
        // cover case for landscape tablet.
        this.navMenuListDiv.nativeElement.addEventListener('touchstart', this.toggleShow, { passive: true });
    }

    clickHandler(): void {
        // rely on hover to show/hide menu for desktop.
        if (!isDesktop()) {
            this.toggleShow();
        }
    }

    toggleShow(): void {
        this.show = !this.show;
    }

    showInviteFriendModal(): void {
        this.ifmc.openModal();
    }
}
